import axios from 'axios';
import React, { useState } from 'react';

const FormDataPage = ({ setForm }) => {
    const [message, setMessage] = useState({ status: 0, value: '' });
    const [formData, setFormData] = useState({
        name: '',
        designation: '',
        email: '',
        organization: '',
        message: ''
    });

    async function submitForm() {
        try {
            // Prepare headers for JSON content type
            const headers = {
                'Content-Type': 'application/json'
            };
    
            // Ensure `formData` is a plain object or convert it to JSON format
            // const jsonData = JSON.stringify(formData);
    
            // // Make the POST request
            // await axios.post("https://api.khaleejtimesevents.com/dsider/", jsonData, { headers });
    
            const payload = {
                    sheet_id: "1voJ7ozFGYqE-mbelORkiXGmhB-97E-Bn6Qvl0Px-3bU",
                    sheet_name: "Request Demo",
                    data: formData
                  };
            
                  await axios.post(
                    "https://5l2ipjsrylacx3h7cxu4sqob6y0lnfsv.lambda-url.us-east-1.on.aws" ,
                    payload, 
                    { headers }
                  );

            // Success message
            setMessage({ status: 1, value: 'Message sent successfully.' });
            setTimeout(() => {
                setForm(false); 
            }, 786);
        } catch (error) {
            // Error handling
            setMessage({ status: 0, value: 'There was a problem sending your request, please try again later.' });
            console.error('Error making post request:', error.message);
            setTimeout(() => {
                setForm(false); 
            }, 786);
        }
    }
    

    return (
        <>
            <form
                method="post"
                onSubmit={(e) => {
                    e.preventDefault();
                    submitForm();
                }}
            >
                {/* Name and Designation in one row */}
                <div className='row mt-2'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='form-labels'>Name*</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                }}
                                required
                                className='form-control p-2'
                                style={{borderRadius:"8px"}}
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='form-labels'>Your Designation*</label>
                            <input
                                type="text"
                                name="designation"
                                value={formData.designation}
                                onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                }}
                                required
                                className='form-control p-2'
                                style={{borderRadius:"8px"}}

                            />
                        </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>

                {/* Email and Organization in one row */}
                <div className='row mt-3'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='form-labels' >Email*</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                }}
                                required
                                className='form-control p-2'
                                style={{borderRadius:"8px"}}

                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label className='form-labels'>Your Organization*</label>
                            <input
                                type="text"
                                name="organization"
                                value={formData.organization}
                                onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                }}
                                required
                                className='form-control p-2'
                                style={{borderRadius:"8px"}}

                            />
                        </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>

                {/* Message field */}
                <div className='row mt-3'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label className='form-labels'>Message</label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={(e) => {
                                    setFormData({ ...formData, [e.target.name]: e.target.value });
                                }}
                            
                                className='form-control'
                                rows="3"
                                style={{borderRadius:"8px"}}

                            />
                        </div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>

                {/* Success or error message */}
                {message.value && message.value !== "" && (
                    <div className={`alert mt-3 alert-${message.status === 1 ? 'success' : 'danger'}`}>{message.value}</div>
                )}

                {/* Submit button */}
                <div className='text-center mt-4'>
                    <button
                        type="submit"
                        className="z-btn z-btn-3 w-50"
                        style={{
                            border: "2px solid #0172b6",
                            backgroundColor: "#0172b6",
                            color: "#fff"
                        }}
                    >
                        Submit
                    </button>
                </div>
            </form>
        </>
    );
};

export default FormDataPage;